/* Shared, human-readable labels for the article sections. */

export const CATEGORIES = [
  { name: 'حملي', key: 'pregnancy', icon: '🤰' },
  { name: 'طفلي', key: 'childcare', icon: '👶' },
  { name: 'بيتي', key: 'home', icon: '🏠' },
  { name: 'كوزينتي', key: 'recipes', icon: '🍳' },
  { name: 'مدرستي', key: 'education', icon: '📚' },
  { name: 'تحويستي', key: 'trips', icon: '✈️' },
  { name: 'صحتي', key: 'health', icon: '💪' },
  { name: 'ديني', key: 'religion', icon: '🕌' },
  { name: 'الأسماء', key: 'names', icon: '🌸' }
];

const BY_KEY = CATEGORIES.reduce((acc, c) => { acc[c.key] = c; return acc; }, {});

export const categoryLabel = (key) => (BY_KEY[key] ? BY_KEY[key].name : key || '');
export const categoryIcon = (key) => (BY_KEY[key] ? BY_KEY[key].icon : '🌷');
